import { useState, useEffect } from 'react';
import { get } from 'lodash';

import { useFormContext } from '@skunexus/form';
import { ajaxExceptionMessage } from '@skunexus/utils';

import * as API from './api';

export const useWarehousesSection = ({ details = {}, errorNotification = () => {} }) => {
    const [warehouses, setWarehouses] = useState([]);
    const [isLoading, setLoading] = useState(false);

    const [{ formikProps = {} }] = useFormContext();
    const { values, setFieldValue } = formikProps;

    useEffect(() => {
        let mounted = true;

        const getDictionaries = async () => {
            setLoading(true);
            try {
                const result = await API.fetchDictionaries();

                const data = get(result, `data.data`);
                if (!data) {
                    throw new Error(`Couldn't load Dictionaries`);
                }
                if (mounted) {
                    setLoading(false);
                    setWarehouses(get(data, 'warehouse.grid.rows', []));
                }
            } catch (e) {
                errorNotification(ajaxExceptionMessage(e));
                if (mounted) {
                    setLoading(false);
                    setWarehouses([]);
                }
            }
        };

        getDictionaries();

        return () => {
            mounted = false;
        };
    }, []);

    useEffect(() => {
        if (!isLoading) {
            setTimeout(() => {
                const { assignedWarehouses = [] } = details;
                if (warehouses.length === 1 && assignedWarehouses.length === 0) {
                    setFieldValue('assignedWarehouses', [get(warehouses[0], 'value', '')]);
                } else if (values.assignedWarehouses.length === 0 && assignedWarehouses.length > 0) {
                    setFieldValue(
                        'assignedWarehouses',
                        assignedWarehouses.map(({ id }) => id),
                    );
                }
            }, 300);
        }
    }, [isLoading, warehouses, details]);

    return [
        {
            warehouses,
            isLoading,
        },
    ];
};
